import script from "./FilePreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./FilePreviewModal.vue?vue&type=style&index=0&id=76de1e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76de1e36"]])

export default __exports__